const MIN_WATCH_DURATION_VIDEO = 30;
const MIN_WATCH_DURATION_BANNER = 10;

/** Время ожидания заполнения AdSense перед показом fallback-заглушки (мс) */
const AD_LOAD_TIMEOUT_MS = 5000;

const AD_SENSE_CLIENT_ID = 'ca-pub-8468025324095319';

export {MIN_WATCH_DURATION_VIDEO, MIN_WATCH_DURATION_BANNER, AD_LOAD_TIMEOUT_MS, AD_SENSE_CLIENT_ID};
